// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","FilterLinks__link":"ce_a bib_h bib_kh bib_we bib_su bib_vt bib_sw bib_sn"};